import { Validators } from '@angular/forms';

export class ApplicationTypeModel {
  applicationType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  furtherAdvanceApplicationType = {
    value: null,
    validation: Validators.compose([])
  };
  vxApplicationType = {
    value: null,
    validation: Validators.compose([])
  };
  appId = {
    value: null,
    validation: Validators.compose([])
  };
  accountNumber = {
    value: null,
    validation: Validators.compose([])
  };
  isStaffApplication = {
    value: false,
    validation: Validators.compose([])
  };
}
